import { SVGProps, Ref, forwardRef } from 'react';

export const MapPinOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.8 11c0-2.233.562-4.272 1.77-5.723C6.73 3.885 8.683 2.8 12 2.8s5.27 1.085 6.43 2.477c1.208 1.45 1.77 3.49 1.77 5.723 0 2.925-1.034 4.61-2.594 6.012-.83.746-1.821 1.42-2.972 2.15-.877.556-1.765 1.097-2.634 1.666-.916-.6-1.825-1.153-2.634-1.667-1.15-.73-2.142-1.403-2.972-2.149C4.834 15.61 3.8 13.925 3.8 11M12 1C4.5 1 2 6 2 11c0 5.684 3.431 7.828 7.311 10.253.885.552 1.793 1.12 2.689 1.747a61 61 0 0 1 2.689-1.747C18.569 18.828 22 16.684 22 11c0-5-2.5-10-10-10M9.8 11c0-.733.187-1.272.458-1.598.223-.267.675-.602 1.742-.602s1.52.335 1.742.602c.271.326.458.865.458 1.598s-.187 1.272-.458 1.598c-.223.267-.675.602-1.742.602s-1.52-.335-1.742-.602C9.987 12.272 9.8 11.733 9.8 11M8 11c0-2 1-4 4-4s4 2 4 4-1 4-4 4-4-2-4-4"
                fill="currentColor"
            />
        </g>
    </svg>
));
MapPinOutlinedSize24Glyph.displayName = 'MapPinOutlinedSize24Glyph';
